export default {
  mounted () {
    /*this.$nextTick(() => {
      this.criterio.value = null
    })
    console.log(this.criterio.value)*/
  }
}
